// extracted by mini-css-extract-plugin
module.exports = {"button":"UserMenu_button__3KtDP","UserMenu":"UserMenu_UserMenu__3VVfi","UserName":"UserMenu_UserName__13Kun"};